import * as Events from './Events';
import * as helper from './../../../Assets/Js/helper';

export default class VideoPlayer {
	constructor(videoEnd) {
		this.timeout = null;
		this._videoEnd = videoEnd;
		this.videoContainer = helper.$('#videoContainerHost');

		this.source = document.createElement('source');
		this.source.setAttribute('src', '');
		this.videoContainer.appendChild(this.source);
		this.ajaxLoader = helper.$('#ajaxloader');

		let liveBadge = this.videoContainer.parentNode.querySelector('.livebadge');

		helper.hide(liveBadge);

		helper.addEventListener(this.source, 'error', () => {
			if (this.timeout !== null) {
				videoEnd();
			}
		});

		let soundButton = document.querySelector('#soundButton .track');

		helper.addEventListener(soundButton, 'click', () => {
			helper.toggleClass(soundButton, 'on');
			helper.toggleClass(soundButton, 'off');

			this.videoContainer.muted = helper.hasClass(soundButton, 'off');
		});

		helper.addEventListener(this.videoContainer, 'playing', () => {
			helper.triggerEvent(window, Events.VIDEO_STARTED_PLAYING);
			helper.show(liveBadge);
			helper.hide(this.ajaxLoader);
		});

		helper.addEventListener(this.videoContainer, 'ended', () => {
			helper.hide(liveBadge);
			helper.show(this.ajaxLoader);
			videoEnd();
		});

		helper.addEventListener(window, Events.CREATE_SIGNUP, () => {
			this.stop();
		});

		helper.addEventListener(window, 'paytourClose', () => {
			this.timeout = setTimeout(function () {
				this._videoEnd();
			}.bind(this), 40000);

			try {
				this.videoContainer.play();
			} catch (e) {
				// Do nothing
			}
		});
	}

	stop() {
		clearTimeout(this.timeout);
		this.videoContainer.pause();
	}

	load(url) {
		clearTimeout(this.timeout);

		// sometimes the videos stop playing, refresh after 40 seconds
		this.timeout = setTimeout(function () {
			this._videoEnd();
		}.bind(this), 40000);
		this.videoContainer.pause();
		helper.show(this.ajaxLoader);
		this.source.setAttribute('src', url);
		try {
			this.videoContainer.load();
			this.videoContainer.play();
		} catch(e) {
			// Do nothing
		}
	}
}
